import { t } from "../../i18n";
import { FileCode2 } from "lucide-react";
import { CopyButton } from "../CopyButton";
import { Card } from "./WorkspaceResultCard";
import { Heading } from "./WorkspaceResultHeading";
import { PathLabel } from "./WorkspaceResultPathLabel";
import {
  payload,
  recordValue,
  shellOutput,
  text,
} from "./WorkspaceResult.utils";

export function ReadResult({
  input,
  result,
}: {
  input: Record<string, unknown>;
  result: unknown;
}) {
  const raw = recordValue(payload(result));
  const content = text(raw.content) || shellOutput(result);
  const path =
    text(raw.path) ||
    text(raw.resolvedPath) ||
    text(input.path) ||
    t("Workspace file");
  return (
    <Card tone="sky">
      <Heading
        icon={
          <FileCode2 size={16} className="text-sky-700 dark:text-sky-300" />
        }
      >
        {t("File contents")}
      </Heading>
      <PathLabel path={path} />
      <div className="mt-2 flex flex-wrap items-center gap-2 text-[11px] text-stone-500">
        {typeof raw.lineCount === "number" && (
          <span>{t("{{count}} lines", { count: raw.lineCount })}</span>
        )}
        {typeof raw.bytes === "number" && (
          <span>{t("{{count}} bytes", { count: raw.bytes })}</span>
        )}
        {raw.truncated === true && (
          <span className="font-semibold text-amber-700 dark:text-amber-300">
            {t("Content truncated")}
          </span>
        )}
      </div>
      <div className="mt-3 overflow-hidden rounded-xl bg-[#101312]">
        <div className="flex justify-end border-b border-white/10 px-2 py-1">
          <CopyButton value={content} label={t("Copy content")} />
        </div>
        <pre className="max-h-[30rem] overflow-auto p-3 font-mono text-[11px] leading-5 whitespace-pre-wrap text-stone-200">
          {content || t("File is empty")}
        </pre>
      </div>
    </Card>
  );
}
